"use client";

import { ShoppingCart } from "lucide-react";
import { useShopCart } from "./ShopCartProvider";

export function ShopCartButton() {
  const { cartCount, openCart } = useShopCart();

  return (
    <button className="cart-pill shop-cart-header-button" type="button" onClick={openCart} aria-label="Abrir carrito">
      <ShoppingCart size={18} />
      <span>{cartCount}</span>
    </button>
  );
}
